import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { State } from '../../../store/reducers';
import { Store } from '@ngrx/store';
import { map, switchMap, tap } from 'rxjs/operators';
import { BookingService } from '../../services/booking.service';

import * as bookingActions from '../../../store/actions/booking.action';
import * as fromUI from '../../../store/actions/ui.action';
import { Observable } from 'rxjs/Observable';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmationComponent implements OnInit, OnDestroy {
  // enableConfirmButton$: Observable<boolean>;
  disableConfirmButton = false;
  addBookingSubscription: Subscription;
  constructor(
    private router: Router,
    private store: Store<State>,
    private spinnerService: Ng4LoadingSpinnerService,
    private bookingService: BookingService
  ) {}

  ngOnInit() {
    // this.enableConfirmButton$ = this.store.select(state => {
    //   return (
    //     state.booking.currentBooking.bookingPrice > 0 &&
    //     state.booking.currentBooking.firstNames.length > 0 &&
    //     state.booking.currentBooking.lastName.length > 0
    //   );
    // });
  }

  goBack() {
    this.router.navigate(['/bookings/add/tour-info']);
  }

  addBooking() {
    this.disableConfirmButton = true;
    // this.store.dispatch(new bookingActions.AddBooking());
    this.addBookingSubscription = this.store
      .select(state => state.booking.currentBooking)
      .subscribe(booking =>
        this.store.dispatch(new bookingActions.AddBooking(booking))
      );
  }

  cancel() {
    this.router.navigate(['/bookings']);
  }

  ngOnDestroy() {
    if (this.addBookingSubscription) {
      this.addBookingSubscription.unsubscribe();
    }
    this.store.dispatch(new bookingActions.ResetCurrentBooking());
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/confirmation/confirmation.component.ts